import { Box, Stack } from '@mui/material';
import { useShow } from '@refinedev/core';
import { Show } from '@refinedev/mui';
import { ReadOnlyField } from '../../../components/fields/ReadOnlyField.tsx';
import { OrganizationWithAccountsAndMagazines } from '../../../types/account.ts';

export const OrganizationShow = () => {
  const {
    query: { data, isLoading },
  } = useShow<OrganizationWithAccountsAndMagazines>({
    resource: 'accounts/organizations',
    queryOptions: {
      select({ data }) {
        return {
          data: OrganizationWithAccountsAndMagazines.parse(data),
        };
      },
    },
  });

  const record = data?.data;

  return (
    <Show isLoading={isLoading}>
      <Stack spacing={2}>
        <Box display="flex" gap={2}>
          <ReadOnlyField name="validFrom" type="date" label="利用開始日" sx={{ flex: 1 }}>
            {record?.validFrom.toLocaleDateString('ja-JP')}
          </ReadOnlyField>
          <ReadOnlyField name="organizationType" label="組織タイプ" sx={{ flex: 1 }}>
            {record?.organizationType?.name}
          </ReadOnlyField>
          <ReadOnlyField name="seller" label="販売経路" sx={{ flex: 1 }}>
            {record?.seller?.name}
          </ReadOnlyField>
        </Box>
        <ReadOnlyField name="name" type="text" label="組織名" fullWidth>
          {record?.name}
        </ReadOnlyField>
        <Box display="flex" gap={2}>
          <ReadOnlyField type="number" label="利用可能ユーザー数" sx={{ flex: 1 }}>
            {record?.accountLimitNum}
          </ReadOnlyField>
          <ReadOnlyField
            name="magazines.nbl.accountLimitNum"
            type="number"
            label="NBLユーザー数"
            sx={{ flex: 1 }}
          >
            {record?.magazines.nbl?.accountLimitNum}
          </ReadOnlyField>
          <ReadOnlyField type="number" label="資料版商事法務ユーザー数" sx={{ flex: 1 }}>
            {record?.magazines.shiryoban?.accountLimitNum}
          </ReadOnlyField>
          <ReadOnlyField type="number" label="旬刊商事法務ユーザー数" sx={{ flex: 1 }}>
            {record?.magazines.junkan?.accountLimitNum}
          </ReadOnlyField>
        </Box>
        <Box>
          {record?.accounts.map((account, index) => (
            <Box key={index} display="flex" gap={2}>
              <ReadOnlyField
                name="adminAccountName"
                type="text"
                label="組織管理者氏名"
                sx={{ flex: 1 }}
              >
                {account.name}
              </ReadOnlyField>
              <ReadOnlyField
                name="adminAccountEmail"
                type="text"
                label="組織管理者メールアドレス"
                sx={{ flex: 1 }}
              >
                {account.email}
              </ReadOnlyField>
            </Box>
          ))}
        </Box>
      </Stack>
    </Show>
  );
};
